import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@procore/core-react';
import customColors from '../../styles/colors';

export const useStyles = makeStyles(() => ({
  title: {
    marginBottom: '15px',
  },
  dataPointContainer: {
    marginBottom: '25px',
  },
  link: {
    display: 'block',
    marginTop: '7px',
    fontSize: '16px',
    fontWeight: 400,
    color: customColors.blue.l45,
  },
  notes: {
    display: 'block',
    marginTop: 0,
    marginLeft: '28px',
    fontSize: '16px',
    fontWeight: 400,
  },
  showMoreOrLessText: {
    color: colors.black,
    display: 'inline-block',
    fontSize: '16px',
    textDecoration: 'underline',
    '&:hover': { cursor: 'pointer' },
  },
}));
